import { NeoModel, ValueObject } from "@singularsystems/neo-core";

@NeoModel
export default class TradeSftpTypeLookup extends ValueObject {
    public tradeSftpTypeId: number = 0;

    public tradeSftpTypeName: string = "";

    public tradeSftpTypeDescription: string = "";
}